/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCashInTransit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 1.586 3.707 3.707-1.414 1.414L13 5.414V9h-2V5.414L9.707 6.707 8.293 5.293 12 1.586zM2 7h7v2H4v11h16V9h-5V7h7v15H2V7zm9 3.5V10h2v.5h2v2h-2v1h.5a2.5 2.5 0 0 1 0 5H13v.5h-2v-.5H9v-2h2v-1h-.5a2.5 2.5 0 0 1 0-5h.5zm0 2h-.5a.5.5 0 0 0 0 1h.5v-1zm2 3v1h.5a.5.5 0 1 0 0-1H13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCashInTransit as CashInTransit };
